<template>
  <div class="accueil-container">

    <div class="header-container">
      <div class="header">
        <div class="navbar">
          <app-accueil-navbar @toggleMenu="toggleMenuTwo" :open="menuShowed"></app-accueil-navbar>
        </div>
        <div class="slider">
        <app-accueil-slider></app-accueil-slider>
        </div>

        <transition name="size-menu">
          <app-accueil-hamburger v-if="this.menuShowed"></app-accueil-hamburger>
        </transition>

        <transition name="opacity">
          <div class="shadow" v-if="this.menuShowed" @click="toggleMenuTwo"></div>
        </transition>
      </div>
    </div>

    <div class="domaine">
      <app-accueil-domaine-activite></app-accueil-domaine-activite>
    </div>

    <div class="qui">
      <app-accueil-qui-sommes-nous></app-accueil-qui-sommes-nous>
    </div>

    <app-accueil-decouvrez></app-accueil-decouvrez>

    <app-accueil-technique-service></app-accueil-technique-service>

    <app-accueil-ingenierie @openImage="open"></app-accueil-ingenierie>
    <transition name="opacity">
      <div class="black-screen" v-if="imageShowed" @click="closeImage"></div>
    </transition>
    <transition name="opacity">
      <div class="image-container" v-if="imageShowed">
        <div @click="closeImage">
          <div class="arrow-container left flex-column" @click.stop="prevImage" v-if="!changingImage">
            <img src="../../img/slider_accueil/fleche.svg" class="arrow" alt="">
          </div>
          <transition name="opacity-speed" mode="out-in">
            <img v-for="(image, index) in images" :src="image.imageName" v-if="image.active" :key="index" class="length-1" alt="" @click.stop="">
          </transition>
          <div class="arrow-container right flex-column" @click.stop="nextImage" v-if="!changingImage">
            <img src="../../img/slider_accueil/fleche.svg" class="arrow" alt="">
          </div>
        </div>
      </div>
    </transition>

    <app-accueil-ecoute></app-accueil-ecoute>

    <div id="confiance"></div>
    <app-accueil-confiance></app-accueil-confiance>

    <app-accueil-contact></app-accueil-contact>

    <app-footer></app-footer>
  </div>
</template>

<script>
    import { menuBus } from '../../main';

    import Navbar from "./Navbar";
    import Slider from "./Slider";
    import DomaineActivite from "./DomaineActivite";
    import QuiSommesNous from "./QuiSommesNous";
    import Decouvrez from "./Decouvrez";
    import TechniqueService from "./TechniqueService";
    import Ingenierie from "./Ingenierie";
    import Ecoute from "./Ecoute";
    import Confiance from "./Confiance";
    import Contact from "./Contact";
    import Footer from "../Footer";
    import HamburgerMenu from "./HamburgerMenu";

    import image1 from "../../img/ingenierie/Accompagnement.jpg";
    import image2 from "../../img/ingenierie/Expertise.jpg";
    import image3 from "../../img/ingenierie/Formation.jpg";
    import image4 from "../../img/ingenierie/Veille_Technologique.jpg";

  export default {
      data() {
          return {
              menuShowed: false,
              imageShowed: false,
              changingImage: false,
              images: [
                  {
                      imageName: image1,
                      active: false,
                  },
                  {
                      imageName: image2,
                      active: false,
                  },
                  {
                      imageName: image3,
                      active: false,
                  },
                  {
                      imageName: image4,
                      active: false,
                  },
              ]
          }
      },
      methods: {
        toggleMenuTwo() {
            this.menuShowed = !this.menuShowed;
            if (this.menuShowed) {
                document.getElementsByTagName('body')[0].classList.add('blocked');
            }
            else {
                document.getElementsByTagName('body')[0].classList.remove('blocked');
            }
        },
          open(imageId) {
              this.unactiveAll();
              this.images[imageId-1].active = true;
              this.imageShowed = true;
              this.changingImage = false;
          },
          closeImage() {
              this.imageShowed = false;
              this.unactiveAll();
          },
          unactiveAll() {
              for (let i=0; i < this.images.length; i++) {
                  this.images[i].active = false;
              }
          },
          imageActiveIndex() {
              for (let i=0; i < this.images.length; i++) if (this.images[i].active == true) return i;
          },
          nextImage() {
            this.changingImage = true;
            if (this.imageActiveIndex()+1 == this.images.length) this.open(1);
            else this.open(this.imageActiveIndex()+2);
          },
          prevImage() {
              this.changingImage = true;
              if (this.imageActiveIndex() == 0) this.open(this.images.length-1);
              else this.open(this.imageActiveIndex());
          }
      },
      mounted() {
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      },
      components: {
          'app-accueil-navbar': Navbar,
          'app-accueil-slider': Slider,
          'app-accueil-domaine-activite': DomaineActivite,
          'app-accueil-qui-sommes-nous': QuiSommesNous,
          'app-accueil-decouvrez': Decouvrez,
          'app-accueil-technique-service': TechniqueService,
          'app-accueil-ingenierie': Ingenierie,
          'app-accueil-ecoute': Ecoute,
          'app-accueil-confiance': Confiance,
          'app-accueil-contact': Contact,
          'app-footer': Footer,
          'app-accueil-hamburger': HamburgerMenu,
      }
  }
</script>

<style scoped>
  .accueil-container {

  }

  .header-container {
    z-index: 100;
  }

  .header {
    position: relative;
    height: 100vh;
    min-height: 800px;
  }
  .navbar {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 100;
  }
  .slider {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 50;
  }

  .black-screen {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 200;
    position: fixed;
    top: 0;
    left: 0;
  }
  .image-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 200;

    max-height: 95vh;
    max-width: 90vw;

    min-width: calc(100% - 200px);
    width: 90%;
    max-width: calc(100% - 50px);
  }
  .image-container > div {
    position: relative;
  }
  .image-container img {
    max-width: 100%;
    max-height: 90vh;
  }
  .image-container .arrow-container {
    position: absolute;
    height: 100%;
    width: 50px;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    opacity: 1;
    transition: opacity 0.2s;
  }
  .image-container .arrow-container.left {
    left: 0;
    align-items: flex-start;
    padding-left: 5px;
    background: rgba(0, 0, 0, 0);
  }
  .image-container .arrow-container.left:hover {
    opacity: 1;
  }
  .image-container .arrow-container.right {
    right: 0;
    align-items: flex-end;
    padding-right: 5px;
    background: rgba(0, 0, 0, 0);
  }
  .image-container .arrow-container.right:hover {
    opacity: 1;
  }

  .image-container .arrow-container .arrow {
    height: 30px;
  }
  .image-container .arrow-container.right .arrow {
    transform: rotate(180deg);
  }

  /* Mobile */
  @media (max-width: 500px) {
    .header {
      min-height: 100vh;
    }
  }

  .size-menu-enter-active,
  .size-menu-leave-active {
    transition: all 0.5s;
    max-height: 500px!important;
  }
  .size-menu-enter,
  .size-menu-leave-to
  {
    opacity: 0;
    max-height: 0px!important;
  }

  .shadow {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 60;
    position: fixed;
  }

  .opacity-enter-active,
  .opacity-leave-active {
    transition: all 0.5s;
  }
  .opacity-enter,
  .opacity-leave-to
  {
    opacity: 0;
  }

  .opacity-speed-enter-active,
  .opacity-speed-leave-active {
    transition: all 0.2s;
  }
  .opacity-speed-enter,
  .opacity-speed-leave-to
  {
    opacity: 0;
  }

  @media (min-width: 1100px) {
    .shadow {
      display: none!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/Accueil.vue